import { ExpandOutlined, CompressOutlined } from '@ant-design/icons';
import { ToolbarTooltip } from '@/features/study-detail/Viewer/ViewerControls/ToolbarTooltip';
import styles from './DetachButton.module.css';

interface DetachButtonProps {
  isDetached: boolean;
  onToggle: () => void;
  disabled?: boolean;
  onMouseEnter?: () => void;
}

/**
 * Floating button for detaching/reattaching the viewer to a popup window
 */
export default function DetachButton({
  isDetached,
  onToggle,
  disabled,
  onMouseEnter,
}: DetachButtonProps) {
  const tooltipText = isDetached
    ? 'Reattach to main window'
    : 'Open viewer in new window';

  return (
    <ToolbarTooltip title={tooltipText}>
      <button
        type="button"
        className={styles.detachButton}
        onClick={onToggle}
        disabled={disabled}
        onMouseEnter={onMouseEnter}
        aria-label={tooltipText}
      >
        {isDetached ? <CompressOutlined /> : <ExpandOutlined />}
      </button>
    </ToolbarTooltip>
  );
}
